import React from 'react'

import { useAuth0 } from '../../Hooks/auth0'
import { Navbar, Icon, Divider } from '@blueprintjs/core'
import { NavButtonMenu, NavButtonLink } from '../../Elements'
import { useMediaQuery } from 'react-responsive'
import {
    CanAdministerUsers,
    CanViewJob,
    CanViewReports,
    CanViewInventory,
    CanViewAdminDashboard,
    CanViewPrintQueue
} from '../../Components/Auth'
// import { OfflineDownloader } from '../../Components'
import ScrollToTopButton from '../ScrollToTopButton'
import Notifications from '../../Components/Notifications'
import { Link } from 'react-router-dom'
import { useLocalStorage } from '../../Hooks/offline'



import {
    JobsMenuItems,
    InventoryMenuItems,
    ReportsMenuItems,
    DigitalBoardMenuItems,
    UtilityShortcutMenuItems,
    AdminMenuItems
} from './shared'
import { useOnlineUtils } from '../../Hooks/offline'

import { logoNav, primaryTheme, envShowCentralTexas } from '../../utils/helpers'


const navHeaderStyle = {
    fontFamily: 'Rockwell',
    paddingTop: 5,
    color: primaryTheme,
    fontSize: '1.2em'
}

const DesktopNavbar = () => {
    const { isLoggedIn } = useAuth0()
    const showNavIcons = useMediaQuery({ query: '(min-width: 1367px)' })
    const showCleanLocalStorageButton = useMediaQuery({ query: '(min-width: 1183px)' })
    const { isOnline } = useOnlineUtils()

    return (

        <Navbar className={isOnline ? 'online-navbar' : 'offline-navbar'} >
            <Navbar.Group style={{ width: '100%' }}>
                <Navbar.Heading className="heading">
                    <Link to={'/'}>
                        {isOnline
                            ? envShowCentralTexas
                                ? <img src={logoNav} width='100%' alt='MMG' style={{ marginTop: 5 }} />
                                : <object type="image/svg+xml" data={logoNav} alt='MMG' width='55px' height='55px' />
                            : <Icon icon='offline' size='40' color='red' style={{ marginTop: 5 }} />
                        }
                    </Link>

                    <Link to={'/'}><span className='nav-header'>Insite</span> </Link>
                </Navbar.Heading>

                {isOnline &&
                    <NavButtonMenu
                        menuIcon={showNavIcons && 'timeline-events'}
                        menuText='Schedule'
                        children={<DigitalBoardMenuItems />}
                    />
                }

                <Navbar.Divider style={{ display: 'inline-block' }} />

                <CanViewJob>
                    <NavButtonMenu
                        style={{ display: 'block' }}
                        menuIcon={showNavIcons && 'briefcase'}
                        menuText='Jobs'
                        children={<JobsMenuItems />}
                    />
                    {isOnline &&
                        <NavButtonLink icon={showNavIcons && 'globe'} text='Search' to='/map' style={{ textAlign: 'center' }} />
                    }
                </CanViewJob>


                <CanViewInventory>
                    {isOnline &&
                        <NavButtonMenu
                            menuIcon={showNavIcons && 'shopping-cart'}
                            menuText='Inventory'
                            children={<InventoryMenuItems />}
                        />
                    }
                </CanViewInventory>

                <CanViewReports>
                    {isOnline &&
                        <NavButtonMenu
                            menuIcon={showNavIcons && 'series-derived'}
                            menuText='Reports'
                            children={<ReportsMenuItems />}
                        />
                    }
                </CanViewReports>

                {isOnline &&
                    <Navbar.Divider style={{ display: 'inline-block' }} />
                }

                <CanViewPrintQueue>
                    {isOnline &&
                        <NavButtonLink icon={showNavIcons && 'numbered-list'} text='Print Queue' to='/print-queue' style={{ textAlign: 'center' }} />
                    }
                </CanViewPrintQueue>

                <CanAdministerUsers>
                    {isOnline &&
                        <NavButtonMenu
                            menuIcon={showNavIcons && 'wrench'}
                            menuText={showNavIcons ? 'Utility' : 'Util Shortcut'}
                            children={<UtilityShortcutMenuItems />}
                        />
                    }
                </CanAdministerUsers>

                <CanAdministerUsers>
                    {isOnline &&
                        <NavButtonLink icon={showNavIcons && 'user'} text='Users' to='/user' style={{ textAlign: 'center' }} />
                    }
                </CanAdministerUsers>

                <CanViewAdminDashboard>
                    {isOnline &&
                        <NavButtonMenu
                            menuIcon={showNavIcons && 'shield'}
                            menuText='Admin'
                            children={<AdminMenuItems />}
                        />
                    }
                </CanViewAdminDashboard>

                {isOnline &&
                    <Navbar.Divider style={{ display: 'inline-block' }} />
                }

                <ScrollToTopButton />

                {isOnline &&
                    <Notifications />
                }

                {/* <OfflineDownloader /> */}

                {!isOnline &&
                    <Navbar.Divider style={{ display: 'inline-block' }} />
                }

                {!isOnline &&
                    <Navbar.Heading className="heading" style={{ ...navHeaderStyle, whiteSpace: 'nowrap', color: 'red' }}>
                        <b>OFFLINE MODE</b>
                    </Navbar.Heading>
                }

                <div style={{ flex: 'auto', textAlign: 'right' }}>
                    {isOnline && showCleanLocalStorageButton && <ClearAppStorageButton />}
                    {isLoggedIn() && <LogoutButton showIcon={showNavIcons} />}
                </div>
            </Navbar.Group>
        </Navbar>
    )
}

const ClearAppStorageButton = () => {
    const { clearAppStorage } = useLocalStorage()
    return <span title='Clean Local Storage'>
        <Icon style={{ marginRight: '10px', cursor: 'pointer' }} icon={'clean'} onClick={clearAppStorage} />
    </span>
}

const LogoutButton = ({ showIcon }) => {
    const { logout, profile } = useAuth0()
    const ButtonText = <div style={{ textAlign: 'center' }}>
        <p style={{ margin: 0 }}>Logout</p>
        <Divider style={{ margin: 0 }} />
        <p style={{ margin: 0 }}>{profile.name}</p>
    </div>

    return <NavButtonLink
        onClick={logout}
        children={ButtonText}
        icon={showIcon && 'log-out'}
    />
}

export { DesktopNavbar }